<!--
    描述：roleLimit
    时间：2021-03-24
    Created by sjq
-->
<template>
    <div class="h100">
        <w-split v-model="splitValueL">
            <div class="h100" slot="left">
                <premTreeTable ref="roleTreeTable" 
                               @row-click="premTreeClick"
                               v-model="saveQuery.limitId"></premTreeTable>
            </div>
            <div class="h100" slot="right">
                <wSplitRight v-model="splitValueR">
                    <div class="h100" slot="left">
                        <roleTreeTable ref="roleTreeTable"
                                       @row-click="roleTreeClick"
                                       @save="roleSave"
                                       v-model="saveQuery.roleIds"
                                       :list="roleTreeData"></roleTreeTable>
                    </div>
                    <div class="h100" slot="right">
                        <el-col :span="11" class="h100" style="border-right:1px solid #eee">
                            <menuTreeTable ref="menuTreeTable"  
                                           @row-click="menuTreeClick"
                                           @save="menuSave"
                                           v-model="saveQuery.menuIds"
                                           :list="menuTreeData"></menuTreeTable>
                        </el-col>
                        <el-col :span="13" class="h100" style="border-right:1px solid #eee">
                            <btnTable ref="btnTable"
                                      :list="btnTreeData"
                                      v-model="saveQuery.btnIds"
                                      @save="btnSave"></btnTable>
                        </el-col>
                    </div>
                </wSplitRight>
            </div>
        </w-split>
    </div>
</template>

<script>
import wSplit from '@/components/split/split'
import wSplitRight from '@/components/split/split'
import premTreeTable from './components/prem_tree_table'
import roleTreeTable from './components/role_tree_table'
import menuTreeTable from './components/menu_tree_table'
import btnTable from './components/btn_table'
import { getRoleAndMenuList, getRolesByLimitId, roleInsert,
         menuInsert, btnInsert } from 'api/system/roleLimit.js'

export default {
    components: {
        wSplit,
        wSplitRight,
        premTreeTable,
        roleTreeTable,
        menuTreeTable,
        btnTable
    },
    data() {
        return {
            //splitValueL: 0.5,
            //splitValueR: 0.3,
            splitValueL: 0.3,
            splitValueR: 0.5,

            clickRoleObj : '',
            clickMenuObj : '',

            roleTreeData: [], // 角色列表源数据
            menuTreeData: [], // 菜单列表源数据
            btnTreeData: [], // 按钮列表

            saveQuery: {
                limitId: '',
                roleId: '',
                menuId: '',
                roleIds: [],
                menuIds: [],
                btnIds: []
            }
        }
    },
    methods: {
        // 请求右侧源数据
		getRoleAndMenuList() {
			getRoleAndMenuList().then(res => {
				// console.log(res)
				this.roleTreeData = res.data.roleData
                this.menuTreeData = res.data.menuData
			})
		},

        // 获取已勾选数据
        getRolesByLimitId(query, type) {
            getRolesByLimitId(query).then(res => {
                // console.log(res)
                switch (type) {
                    case 'role':
                        this.saveQuery.roleIds = res.data
                        break
                    case 'menu':
                        this.saveQuery.menuIds = res.data
                        break
                    case 'btn':
                        this.btnTreeData = []
                        this.btnTreeData = res.data
                        // this.saveQuery.menuIds = res.data
                        break    
                    default:
                        break
                }
            })
        },

        // 权限行点击
        premTreeClick() {
            this.$nextTick(() => {
                this.getRolesByLimitId({
                    limitId: this.saveQuery.limitId
                }, 'role')
            })
        },

        // 角色组件保存事件
        roleSave() {
            if (this.saveQuery.limitId.length === 0) {
                this.$message({
                    type: 'warning',
                    message: '请选择权限'
                })
                return
            }
            let list = []
			if (this.saveQuery.roleIds.length > 0) {
				this.saveQuery.roleIds.map(i => {
					list.push({
						roleId: i,
						menuIds: []
					})
				})
			}
            roleInsert({
                limitId: this.saveQuery.limitId,
                roleIds: list
            })
        },

        // 角色行点击
        roleTreeClick(id) {
            this.saveQuery.roleId = id
            this.getRolesByLimitId({
                limitId: this.saveQuery.limitId,
                roleId: this.saveQuery.roleId
            }, 'menu')
        },

        // 菜单组件保存事件
        menuSave() {
            if (this.saveQuery.limitId.length === 0) {
                this.$message({
                    type: 'warning',
                    message: '请选择权限'
                })
                return
            }
            let list = []
			if (this.saveQuery.menuIds.length > 0) {
				this.saveQuery.menuIds.map(i => {
					list.push({
						menuId: i,
						btnIds: []
					})
				})
			}
            menuInsert({
                limitId: this.saveQuery.limitId,
                roleIds: [
                    {
                        roleId: this.saveQuery.roleId,
                        menuIds: list
                    }
                ]
            })
        },

        // 菜单行点击
        menuTreeClick(id){
            this.saveQuery.menuId = id
            this.getRolesByLimitId({
                limitId: this.saveQuery.limitId,
                roleId: this.saveQuery.roleId,
                menuId: this.saveQuery.menuId
            }, 'btn')
        },

        // 按钮列表保存事件
        btnSave() {
            if (this.saveQuery.limitId.length === 0) {
                this.$message({
                    type: 'warning',
                    message: '请选择权限'
                })
                return
            }
            console.log(JSON.stringify({
                limitId: this.saveQuery.limitId,
                roleIds: [
                    {
                        roleId: this.saveQuery.roleId,
                        menuIds: [
                            {
                                menuId: this.saveQuery.menuId,
                                btnIds: this.saveQuery.btnIds
                            }
                        ]
                    }
                ]
            }))
            btnInsert({
                limitId: this.saveQuery.limitId,
                roleIds: [
                    {
                        roleId: this.saveQuery.roleId,
                        menuIds: [
                            {
                                menuId: this.saveQuery.menuId,
                                btnIds: this.saveQuery.btnIds
                            }
                        ]
                    }
                ]
            })
        }
    },
    // 进入缓存页面
    activated() {
        this.splitValueL = 0.3
        this.splitValueR = 0.5
    },
    created() {
        this.getRoleAndMenuList()
    },
    watch: {
        'saveQuery.limitId'(val) {
            // console.log(val)
            this.$refs.menuTreeTable.clearChecked()
            this.btnTreeData = []
        },

        'saveQuery.roleId'(val) {
            this.btnTreeData = []
        }
    }
}
</script>

<style scoped lang="less">
.role-manage-main {
    height: 100%;
}
.w-page-main .w-page-header {
    position: relative;
    top: 0;
    left: 0;
    padding: 0 10px;
    width: 100%;
    height: 48px;
    line-height: 48px;
    background-color: #fff;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
}
</style>
